















import { Component, Vue, Prop } from 'vue-property-decorator';
import MaterialRequestForm from '@/components/forms/MaterialRequestForm.vue';
import { Route, RawLocation } from 'vue-router';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate'
]);

@Component({
    components: {
        MaterialRequestForm
    }
})
export default class RequestEdit extends Vue {
    public $refs!: {
        materialRequestForm: MaterialRequestForm
    };

    @Prop() public id!: string | number;
    public beforeRouteUpdate(
        to: Route, from: Route, next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) {
            this.$refs.materialRequestForm.updateForm();
            next();
    }
}
